module.exports = __webpack_public_path__ + "img/metaImage_01.13adbf1e.png";